import React from 'react';
import { Prompt } from 'react-router';
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { allowLeavingForm } from 'modules/formLeaving';

export default () => {
  const anyFormChanged = useSelector(s => s.formLeaving.anyFormChanged, shallowEqual);
  const dispatch = useDispatch();
  return (
    <Prompt
      when={anyFormChanged}
      message={() => {
        dispatch(allowLeavingForm());
        return 'You have unsaved changes, are you sure you want to leave?'
      }}
    />
  )
}
